// extracted by mini-css-extract-plugin
module.exports = {"content":"Activities_content__YAJvp","activityInfo":"Activities_activityInfo__Lvg18"};